(() => {
  if (window.__mkProductCardsBooted) return;
  window.__mkProductCardsBooted = true;
  const YOTPO_APP_KEY = 'ZMo7LkExdnYNcDjjdMwMYCdD1tFKyARho5AEezkt';

  const parseProduct = (card) => {
    const source = card.querySelector('[data-mk-product-json]');
    if (!source) return null;
    try { return JSON.parse(source.textContent); } catch (_) { return null; }
  };

  const money = (cents, currency = 'USD') => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency, maximumFractionDigits: 2,
      }).format(value);
    } catch (_) { return `$${value.toFixed(2)}`; }
  };

  const initialVariant = (card, product) => {
    const id = String(card.dataset.mkInitialVariantId || '');
    return product.variants?.find((variant) => String(variant.id) === id)
      || product.variants?.find((variant) => variant.available)
      || product.variants?.[0]
      || null;
  };

  const skioPlans = (product) => {
    const group = (product.selling_plan_groups || []).find((item) => String(item.app_id || item.appId || '').toUpperCase() === 'SKIO');
    return group?.selling_plans || group?.sellingPlans || [];
  };

  const planId = (plan) => String(plan?.id || '');
  const allocationPlanId = (allocation) => String(allocation?.selling_plan_id || allocation?.sellingPlanId || allocation?.selling_plan?.id || '');
  const allocationFor = (variant, plan) => (variant?.selling_plan_allocations || []).find((item) => allocationPlanId(item) === planId(plan));

  const discountFor = (variant, plan, allocation) => {
    const adjustment = plan?.price_adjustments?.[0] || plan?.priceAdjustments?.[0];
    if (adjustment?.value_type === 'percentage' || adjustment?.valueType === 'PERCENTAGE') {
      return Math.round(Number(adjustment.value ?? adjustment.adjustmentValue?.percentage ?? 0));
    }
    if (allocation?.price && variant?.price) return Math.round((1 - Number(allocation.price) / Number(variant.price)) * 100);
    return 0;
  };

  const subscriptionPriceFor = (variant, allocation, discount) => (
    allocation?.price != null
      ? Number(allocation.price)
      : Math.round(Number(variant.price || 0) * (1 - Number(discount || 0) / 100))
  );

  const quantityRule = (variant) => {
    const rule = variant?.quantity_rule || variant?.quantityRule || {};
    const min = Math.max(1, Number(rule.min || 1));
    const increment = Math.max(1, Number(rule.increment || 1));
    const configuredMax = rule.max == null || rule.max === '' ? 10 : Number(rule.max);
    return { min, max: Math.max(min, Math.min(10, configuredMax)), increment };
  };

  const updateQuantity = (card, variant, requestedValue) => {
    const input = card.querySelector('[data-mk-quantity-input]');
    const display = card.querySelector('[data-mk-quantity-display]');
    const decrease = card.querySelector('[data-mk-quantity-decrease]');
    const increase = card.querySelector('[data-mk-quantity-increase]');
    if (!input || !display || !variant) return;
    const { min, max, increment } = quantityRule(variant);
    let quantity = Number(requestedValue ?? input.value ?? min);
    quantity = Math.max(min, Math.min(max, quantity));
    quantity = min + Math.round((quantity - min) / increment) * increment;
    quantity = Math.max(min, Math.min(max, quantity));
    input.value = String(quantity);
    display.textContent = String(quantity);
    if (decrease) decrease.disabled = quantity <= min;
    if (increase) increase.disabled = quantity >= max;
  };

  const cadenceFor = (frequency, plan) => (frequency?.selectedOptions?.[0]?.textContent || plan?.name || '')
    .trim().replace(/^(delivery|deliver)\s*/i, '').replace(/^every\s*/i, '').trim();

  let activeSubscriptionPopover = null;

  const focusableIn = (container) => [...container.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')]
    .filter((element) => !element.hidden && element.getClientRects().length);

  const closeSubscriptionPopover = (card, returnFocus = false) => {
    const panel = card?.querySelector('[data-mk-subscription-details-popover]');
    const trigger = card?.querySelector('[data-mk-subscription-details-trigger]');
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    trigger?.setAttribute('aria-expanded', 'false');
    card.classList.remove('is-details-open');
    if (activeSubscriptionPopover?.card === card) activeSubscriptionPopover = null;
    if (returnFocus) trigger?.focus();
  };

  const refreshHomepageCarouselDeliveryRow = (card) => {
    if (!window.matchMedia?.('(max-width: 749px)').matches) return;
    if (!card.closest('.featured-collection .product-grid.slider')) return;
    const row = card.querySelector('[data-mk-subscription-row]');
    if (!row) return;
    row.style.setProperty('display', 'none', 'important');
    void row.offsetHeight;
    row.style.removeProperty('display');
  };

  const openSubscriptionPopover = (card) => {
    const panel = card.querySelector('[data-mk-subscription-details-popover]');
    const trigger = card.querySelector('[data-mk-subscription-details-trigger]');
    if (!panel || !trigger) return;
    if (activeSubscriptionPopover?.card === card) {
      closeSubscriptionPopover(card, true);
      return;
    }
    if (activeSubscriptionPopover) closeSubscriptionPopover(activeSubscriptionPopover.card);
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    card.classList.add('is-details-open');
    activeSubscriptionPopover = { card, panel, trigger };
    panel.querySelector('[data-mk-subscription-details-close]')?.focus();
  };

  const handlePopoverKeyboard = (event) => {
    if (!activeSubscriptionPopover) return;
    const { card, panel } = activeSubscriptionPopover;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeSubscriptionPopover(card, true);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = focusableIn(panel);
    if (!focusable.length) {
      event.preventDefault();
      panel.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  document.addEventListener('pointerdown', (event) => {
    if (!activeSubscriptionPopover) return;
    const { card, panel, trigger } = activeSubscriptionPopover;
    if (!panel.contains(event.target) && !trigger.contains(event.target)) closeSubscriptionPopover(card);
  });
  document.addEventListener('keydown', handlePopoverKeyboard);

  const updateCard = (card, product) => {
    const variant = initialVariant(card, product);
    if (!variant) return;
    const currency = card.dataset.currency || 'USD';
    const plans = skioPlans(product);
    const frequency = card.querySelector('[data-mk-subscription-frequency]');
    let plan = plans.find((item) => planId(item) === String(frequency?.value || ''))
      || plans.find((item) => allocationFor(variant, item))
      || null;
    let allocation = allocationFor(variant, plan);
    if (!allocation) {
      plan = plans.find((item) => allocationFor(variant, item)) || null;
      allocation = allocationFor(variant, plan);
    }
    if (frequency && plan && frequency.value !== planId(plan)) frequency.value = planId(plan);

    const hasSubscription = Boolean(plan && allocation && card.querySelector('[data-mk-purchase-options]:not(.is-reserved)'));
    let mode = card.dataset.mkPurchaseMode || 'one-time';
    if (!hasSubscription) mode = 'one-time';
    const subscription = mode === 'subscription' && hasSubscription;
    card.dataset.mkPurchaseMode = subscription ? 'subscription' : 'one-time';

    const discount = discountFor(variant, plan, allocation);
    const subscriptionPrice = subscriptionPriceFor(variant, allocation, discount);
    const idInput = card.querySelector('.product-variant-id');
    const sellingPlanInput = card.querySelector('[data-mk-selling-plan]');
    const addButton = card.querySelector('.mk-product-card__add');
    const addLabel = card.querySelector('[data-mk-add-label]');
    const oneTimePrice = card.querySelector('[data-mk-one-time-price]');
    const subscriptionPriceNode = card.querySelector('[data-mk-subscription-price]');
    const subscriptionCompare = card.querySelector('[data-mk-subscription-compare]');
    const discountLabel = card.querySelector('[data-mk-subscription-discount]');
    const helperOneTime = card.querySelector('[data-mk-helper-one]');
    const helperSubscription = card.querySelector('[data-mk-helper-sub]');
    const helperDetailsTrigger = card.querySelector('[data-mk-subscription-details-trigger]');
    const setHelperVisibility = (element, visible) => {
      if (!element) return;
      element.hidden = !visible;
      element.setAttribute('aria-hidden', String(!visible));
    };

    if (idInput) { idInput.value = variant.id; idInput.disabled = !variant.available; }
    updateQuantity(card, variant);
    if (frequency) {
      frequency.disabled = !subscription;
    }
    if (!subscription) closeSubscriptionPopover(card);
    setHelperVisibility(helperOneTime, !subscription);
    setHelperVisibility(helperSubscription, subscription);
    setHelperVisibility(helperDetailsTrigger, subscription);
    if (sellingPlanInput) sellingPlanInput.value = subscription ? planId(plan) : '';
    if (oneTimePrice) oneTimePrice.textContent = money(variant.price, currency);
    if (subscriptionPriceNode) subscriptionPriceNode.textContent = hasSubscription ? money(subscriptionPrice, currency) : '';
    if (subscriptionCompare) subscriptionCompare.textContent = money(variant.price, currency);
    if (discountLabel) discountLabel.textContent = discount > 0 ? `${discount}% OFF` : 'SAVE';
    card.classList.toggle('is-subscription', subscription);
    card.classList.toggle('is-sold-out', !variant.available);
    card.querySelectorAll('[data-mk-purchase-option]').forEach((button) => {
      const selected = button.dataset.mkPurchaseOption === (subscription ? 'subscription' : 'one-time');
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });

    if (addButton) addButton.disabled = !variant.available;
    if (addLabel) addLabel.textContent = !variant.available ? 'Sold out' : subscription ? (card.dataset.mkDefaultPurchase === 'subscription' ? 'Subscribe & save' : 'Subscribe') : 'Add to cart';
    if (addButton) {
      const cadence = cadenceFor(frequency, plan);
      const accessiblePrice = subscription ? `${money(subscriptionPrice, currency)}${cadence ? ` every ${cadence}` : ''}` : money(variant.price, currency);
      addButton.setAttribute('aria-label', !variant.available ? 'Sold out' : `${subscription ? 'Subscribe' : 'Add to cart'}, ${accessiblePrice}`);
    }
    refreshHomepageCarouselDeliveryRow(card);
  };

  const initialiseCard = (card) => {
    if (card.dataset.mkInitialised === 'true') return;
    const product = parseProduct(card);
    if (!product) return;
    card.dataset.mkInitialised = 'true';
    card.dataset.mkPurchaseMode = card.dataset.mkDefaultPurchase === 'subscription' ? 'subscription' : 'one-time';
    card.querySelectorAll('[data-mk-purchase-option]').forEach((button) => button.addEventListener('click', () => {
      if (button.closest('.is-reserved')) return;
      card.dataset.mkPurchaseMode = button.dataset.mkPurchaseOption;
      updateCard(card, product);
    }));
    card.querySelector('[data-mk-subscription-details-trigger]')?.addEventListener('click', () => {
      if (!card.classList.contains('is-subscription')) return;
      openSubscriptionPopover(card);
    });
    card.querySelector('[data-mk-subscription-details-close]')?.addEventListener('click', () => closeSubscriptionPopover(card, true));
    card.querySelector('[data-mk-subscription-frequency]')?.addEventListener('change', () => updateCard(card, product));
    card.querySelector('[data-mk-quantity-decrease]')?.addEventListener('click', () => {
      const variant = initialVariant(card, product);
      const { increment } = quantityRule(variant);
      const current = Number(card.querySelector('[data-mk-quantity-input]')?.value || 1);
      updateQuantity(card, variant, current - increment);
    });
    card.querySelector('[data-mk-quantity-increase]')?.addEventListener('click', () => {
      const variant = initialVariant(card, product);
      const { increment } = quantityRule(variant);
      const current = Number(card.querySelector('[data-mk-quantity-input]')?.value || 1);
      updateQuantity(card, variant, current + increment);
    });
    updateCard(card, product);
  };

  const loadRating = async (rating) => {
    if (rating.dataset.mkRatingLoaded === 'true') return;
    rating.dataset.mkRatingLoaded = 'true';
    const productId = rating.dataset.yotpoProductId;
    if (!productId) return;
    try {
      const response = await fetch(`https://api-cdn.yotpo.com/products/${YOTPO_APP_KEY}/${productId}/bottomline`, { headers: { accept: 'application/json' } });
      if (!response.ok) throw new Error();
      const bottomline = (await response.json())?.response?.bottomline;
      const score = Number(bottomline?.average_score || 0);
      const count = Number(bottomline?.total_reviews || 0);
      if (!score || !count) { rating.classList.add('is-empty'); rating.setAttribute('aria-busy', 'false'); return; }
      rating.querySelector('.mk-product-card__stars')?.style.setProperty('--mk-rating-percent', `${Math.min(100, Math.max(0, (score / 5) * 100))}%`);
      const text = `${score.toFixed(1)} · ${count} ${count === 1 ? 'review' : 'reviews'}`;
      const textNode = rating.querySelector('[data-mk-rating-text]');
      if (textNode) textNode.textContent = text;
      rating.setAttribute('aria-label', `${score.toFixed(1)} out of 5 stars from ${count} ${count === 1 ? 'review' : 'reviews'}`);
      rating.setAttribute('aria-busy', 'false');
      rating.classList.add('is-ready');
    } catch (_) {
      rating.classList.add('is-empty');
      rating.setAttribute('aria-busy', 'false');
    }
  };

  const initialiseRatings = () => {
    const targets = [...document.querySelectorAll('[data-mk-yotpo-rating]')];
    if (!('IntersectionObserver' in window)) { targets.forEach(loadRating); return; }
    const observer = new IntersectionObserver((entries, active) => entries.forEach((entry) => {
      if (entry.isIntersecting) { loadRating(entry.target); active.unobserve(entry.target); }
    }), { rootMargin: '200px 0px' });
    targets.forEach((target) => observer.observe(target));
  };

  const initialise = () => {
    document.querySelectorAll('[data-mk-product-card]').forEach(initialiseCard);
    initialiseRatings();
  };
  const observeSpectrumGrid = () => {
    const grid = document.querySelector('.mk-spectrum-grid #ProductGridContainer');
    if (!grid) return;
    // Native facets replace the grid contents. Initialise the new cards without
    // changing cards the customer has already configured.
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; initialise(); });
    }).observe(grid, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeSpectrumGrid, { once: true });
  else observeSpectrumGrid();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
